import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './InlineLink.module.scss'
import { InlineLinkProps } from './types'

const InlineLink: React.FC<InlineLinkProps> = forwardRef(
  ({ children, className, token, hasDataTrackingPii, testId, ...props }) => (
    <a
      className={cn(styles.inlineLink, className, token && styles[`inlineLink_${token}`])}
      data-tracking-pii={hasDataTrackingPii}
      data-testid={testId}
      {...props}
    >
      {children}
    </a>
  ),
)

export default InlineLink
